(function ($) {
  $(function () {
    $(".faq p").hide();
    $(".faq h2").on("click", function () {
      $(this).next("p").toggle(300);
    });
  });
})(jQuery);
